<div class="pager-wrapper">

  <div class="box-wrapper">
    <div class="product-style">
      {{dataPack.product.name}}
    </div>
  </div>

  <div class="box-wrapper">
    <div class="member-style">
      {{dataPack.member.name}}
    </div>
    <div class="category-style">
      {{dataPack.subCategory.name}}
    </div>
  </div>

  <div class="box-wrapper" *ngIf="dataPack.events[0].ticket_by_topic">
    <div *ngFor="let topic of dataPack.events[0].topics">
      <div>
        {{topic.name}}
      </div>

    </div>
  </div>

  <div class="box-wrapper" *ngIf="!dataPack.events[0].ticket_by_topic">

  </div>

</div>